import { IBillGroupRespUI } from '@monetize/types/app';
import { useNavigate } from 'react-router-dom';
import DataTableActions, {
  ActionType,
} from '../../../components/Monetize/DataTable/MDataTableActions';
import { ROUTES } from '../../../constants';
import { useACL } from '../../../services/acl/acl';

interface BillGroupActionsProps {
  billGroup: IBillGroupRespUI;
}

export const BillGroupActions = ({ billGroup }: BillGroupActionsProps) => {
  const navigate = useNavigate();

  const { canDo } = useACL();

  const canAccountBillGroupUpdate = canDo([['billing', 'update']]);

  const actions: ActionType[] = [
    {
      title: 'Edit',
      enabled: canAccountBillGroupUpdate,
      action: () => {
        navigate(
          canAccountBillGroupUpdate
            ? `${ROUTES.getBillGroupPageRoute(
                billGroup.id!,
                'details',
              )}?editMode`
            : ROUTES.getBillGroupPageRoute(billGroup.id!, 'details'),
        );
      },
    },
  ];

  return <DataTableActions actions={actions} />;
};
